import { checkup } from '../../api'

const state = {
  checkup: {
    checkupList: [],
    checkupDate: [],
    checkupListDate: [],
    checkupDetail: [],
    requestData: {
      categoryCode: '',
      checkupCode: '',
      checkupDate: ''
    }
  }
}

const getters = {
  getCheckupDate: state => state.checkup.checkupDate,
  getCheckup: state => state.checkup.requestData,
  getCheckupDetail: state => state.checkup.checkupDetail,
  getCheckupList: state => state.checkup.checkupList
}

const mutations = {
  SET_CHECKUP_LIST (state, payload) {
    state.checkup.checkupList = payload
  },
  SET_CHECKUP_DATE (state, payload) {
    state.checkup.checkupDate = payload
  },
  SET_CHECKUP_DETAIL (state, payload) {
    state.checkup.checkupDetail = payload
  },
  SET_CHECKUP (state, payload) {
    state.checkup.requestData = payload
  }
}
const actions = {
  CHECKUP_LIST ({ commit }, payload) {
    return checkup.checkupList(payload)
      .then((data) => commit('SET_CHECKUP_LIST', data.response.checkupList))
  },
  CHECKUP_DETAIL ({ commit }, payload) {
    return checkup.checkupDetail(payload)
      .then((data) => commit('SET_CHECKUP_DETAIL', data.response))
  }
}

export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
